/* eslint no-template-curly-in-string: 0 */
import venmoIcon from '../../assets/images/venmo-icon.svg';
import venmoLogo from '../../assets/images/venmo-logo.png';
import { FLOW_TYPES, PAYMENT_NETWORKS } from "../../utils/enums";

export const dashVenmo = {
  id: PAYMENT_NETWORKS.VENMO_DASH,
  displayName: "Venmo",
  paywall: {
    tile: {
      displayName: "Venmo",
      tagline: ["Delivered in 1-3 business days"],
      description: [
        {
          string: "Funds sent to the account associated with your Venmo phone number",
          type: "div"
        }
      ],
      // btnLabel: "Next",
      logo: venmoIcon
    }
  },
  acceptPayment: {
    imgSrc: venmoLogo,
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.TWO_FACTOR,
    twoFactor: {
      type: 'phone_number',
      getId: {
        description: [
          'Please enter the phone number associated with your ',
          {
            string: "${paymentNetwork.displayName}",
            props: {
              className: 'payment-paymentNetwork'
            }
          },
          ' account.',
        ],
        // secondaryText: 'You will receive an SMS text message with a one-time code to confirm successful delivery to your mobile device.'
      },
      confirmId: {
        description: [
          "Verify your phone number is correct and tied to your Venmo account. An error in your phone number can result in a lost or non-recoverable payment."
        ],
        confirmationText: [
          "I understand and confirm this is the correct number for my Venmo account.",
        ]
      },
    },
    title: 'Receive with Venmo',
    description: [
      "Please enter the 10-digit phone number associated with your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork'
        }
      },
      " account."
    ],
  },
  paymentComplete: {
    initial: {
      description: [
        "Please check your email for details regarding your ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " payment for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: [
        'Your Venmo payment was sent to ',
        {
          string: "${payment.paymentNetworkRecipientId}",
          transformations: [
            {
              type: "formatPhoneNumber"
            }
          ],
          props: {
            className: "payment-recipientEmail",
          }
        },
        '.'
      ]
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          "string": "${payment.recipientEmail}",
          "props": {
            "className": "payment-recipientEmail"
          }
        },
        " on ",
        {
          "string": "${payment.completedAt}",
          "props": {
            "className": "payment-updatedAt"
          },
          "transformations": [
            {
              "type": "formatDate"
            }
          ]
        },
        " with details regarding your Venmo payment for ",
        {
          "string": "${payment.acceptedAmount}",
          "transformations": [
            {
              "type": "formatAsCurrency",
              "data": {
                "currency": "${payment.acceptedCurrency}"
              }
            }
          ],
          "props": {
            "className": "payment-amount"
          }
        },
      ],
      secondaryText: [
        'Your Venmo payment was sent to ',
        {
          string: "${payment.paymentNetworkRecipientId}",
          transformations: [
            {
              type: "formatPhoneNumber"
            }
          ],
          props: {
            className: "payment-recipientEmail",
          }
        },
        '.'
      ]
    },
    imgSrc: venmoLogo,
  },
  onHold: {
    imgSrc: venmoLogo,
  },
  networkSelectionAccepted: {
    imgSrc: venmoLogo,
    title: ["Success!"],
    description: [
      "Please check your email for details regarding your ",
      {
        string: "${paymentNetwork.displayName}",
        props: {
          className: 'payment-paymentNetwork',
        }
      },
      " payment for ",
      {
        string: "${payment.acceptedAmount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.acceptedCurrency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      ". It should arrive in 1-3 business days."
    ],
    secondaryText: [
      'Your Venmo payment was sent to ',
      {
        string: "${payment.paymentNetworkRecipientId}",
        transformations: [
          {
            type: "formatPhoneNumber"
          }
        ],
        props: {
          className: "payment-recipientEmail",
        }
      },
      '.'
    ]
  },
};

export default dashVenmo;
